export enum MODAL_TYPE {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    ALERT = "ALERT",
    CONFIRM = "CONFIRM"
}
